<div class="input-permission-selector-container">

  <ag-grid-angular
    (gridReady)="onLockedGridReady($event)"
    *ngIf='lockedGridOptions && lockedColumnsDef && lockedColumnsDef.length > 0'
    [columnDefs]='lockedColumnsDef'
    [gridOptions]='lockedGridOptions'
    [rowData]='lockedTableData'
    class='ag-theme-balham w-100'
    style='height: 150px; margin-bottom: 10px;'>
  </ag-grid-angular>

  <ng-template #nameLockedCol let-node>
    <pt-icon *ngIf="node.row.id !== ownerId"
             [key]='lockedIcon'
             class="me-1"
             container='body'
             ngbTooltip="{{'TOOLTIP.ADMIN' | translate}}"></pt-icon>
    <pt-icon *ngIf="node.row.id === ownerId" [key]="userIcon"
             container='body'
             ngbTooltip="{{'TOOLTIP.CREATOR' | translate}}"
    ></pt-icon>
    {{ node.row.name }}

  </ng-template>

  <div class="user-group-select-container">
    <pt-input-label
      *ngIf='label'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    ></pt-input-label>
    <div
      *ngIf="formGroup"
      [class.is-invalid]='formGroup.invalid && formGroup.touched'
      [class.ng-dirty]=formGroup.dirty
      [class.ng-invalid]='formGroup.invalid && formGroup.touched'
      [class.ng-touched]=formGroup.touched
      [class.ng-valid]=formGroup.valid>
      <div class="ng-select-permission-container">
        <ng-select
          [(ngModel)]="selectedUsersOrGroups"
          [closeOnSelect]="false"
          [disabled]="unselectedUsersOrGroups.length === 0"
          [hideSelected]="false"
          [id]='inputId'
          [items]='unselectedUsersOrGroups'
          [multiple]='true'
          [placeholder]='placeholder'
          [readonly]='isDisabled'
          [searchFn]="customSearchFn"
          style="width: 380px;">

          <ng-template let-clear="clear" let-items="items" ng-multi-label-tmp>
            <div *ngFor="let item of items | slice:0:1" class="ng-value">
              <span class="ng-value-label">
                {{ $any(item).name }}
              </span>
              <span (click)="clear($any(item))" aria-hidden="true" class="ng-value-icon right">×</span>
            </div>
            <div *ngIf="items && items.length > 1" class="ng-value">
              <span class="ng-value-label">{{ items.length - 1 }} more...</span>
            </div>
          </ng-template>

          <ng-template let-index="index" let-item="item" let-search="searchTerm" ng-option-tmp>
            <div class="d-flex align-items-center">
              <pt-icon *ngIf='item.type' [key]='item.type === "USER" ? "person" : "people"' class="me-1"></pt-icon>
              <span [innerHTML]="item.name | highlight: search"></span>
            </div>
          </ng-template>
        </ng-select>

        <button (click)='addNewUserOrUserGroup()' [disabled]="selectedUsersOrGroups.length === 0"
                [ngClass]="{'opacity-25': selectedUsersOrGroups.length === 0}"
                class='btn btn-outline-dark opacity-25'
                type='button'>
          {{ 'BUTTON.ADD' | translate }}
        </button>
      </div>

    </div>

  </div>

  <ag-grid-angular
    (gridReady)="onGridReady($event)"
    *ngIf='gridOptions && columnsDef && columnsDef.length > 0'
    [columnDefs]='columnsDef'
    [gridOptions]='gridOptions'
    [rowData]='tableData'
    class='ag-theme-balham w-100'
    style="height: 200px;">
  </ag-grid-angular>


  <ng-template #nameCol let-node>
    <div *ngIf="isAdmin" class="btn btn-link"
         style="padding: 0;
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-top: 2px;"

         (click)="openGroup(node.row)">
      <pt-icon *ngIf='node.row.type' [key]='node.row.type === "USER" ? "person" : "people"' class="me-1"></pt-icon>
      {{ node.row.name }}
    </div>

    <div *ngIf="!isAdmin">
      <pt-icon *ngIf='node.row.type' [key]='node.row.type === "USER" ? "person" : "people"' class="me-1"></pt-icon>
      {{ node.row.name }}

    </div>
  </ng-template>


  <ng-template #accessCol let-node>
    <ng-select
      (close)="closeTableRowAccess()"
      (ngModelChange)="changeTableRowAccess(node.row, $event)"
      [className]="'permission-table-select'"
      [closeOnSelect]="false"
      [disabled]="accessValue.length === 0 || isDisabled"
      [hideSelected]="false"
      [items]='accessValue'
      [multiple]='false'
      [ngClass]="{'opacity-50': accessValue.length === 0 || isDisabled }"
      [ngModel]="node.row.access"
      [readonly]='accessValue.length === 0 || isDisabled'
      appendTo=".input-permission-selector-container"
    >

      <ng-template let-clear="clear" let-item="item" ng-label-tmp>
        <div class="ps-1 pe-1">
          {{ 'ENUMS.' + item | translate }}
        </div>
      </ng-template>

      <ng-template let-index="index" let-item="item" let-search="searchTerm" ng-option-tmp>
        {{ 'ENUMS.' + item | translate }}
      </ng-template>

    </ng-select>
  </ng-template>

  <ng-template #actionCol let-node>
    <ng-select
      (close)="closeTableRowAction()"
      (ngModelChange)="changeTableRowAction(node.row, $event)"
      (clear)="clearRow(node.row)"
      [className]="'permission-table-select'"
      [closeOnSelect]="false"
      [disabled]="actionValue.length === 0 || node.row.access === 'NONE' || isDisabled"
      [hideSelected]="false"
      bindValue="name"
      bindLabel="name"
      [items]='node.row.access === "READ_ONLY" ? actionReadOnlyValue : actionWriteValue'
      [multiple]='true'
      [ngModel]="node.row.actions"
      [placeholder]="'ENUMS.NONE' | translate"
      [readonly]="actionValue.length === 0 || node.row.access === 'NONE' || isDisabled"
      appendTo=".input-permission-selector-container">
      <ng-template let-clear="clear" let-items="items" ng-multi-label-tmp>
        <div *ngFor="let item of items | slice:0:1" class="ng-value d-flex" container='body'
             ngbTooltip="{{ 'ENUMS.' + $any(item).name | translate }}">
          <span class="ng-value-label text-truncate doc-permission-item">
              {{ 'ENUMS.' + $any(item).name | translate }}
          </span>
          <span (click)="removeTableRowAction(node.row, $any(item))" aria-hidden="true" class="ng-value-icon right">×</span>
        </div>
        <div *ngIf="items && items.length > 1" class="ng-value">
          <span class="ng-value-label"> {{ items.length - 1 }} more...</span>
        </div>
      </ng-template>

      <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
        <div style="display: flex; align-items: center">
          <input class="me-2" id="item-{{index}}" type="checkbox"
                 [disabled]="item.disabled"
                 [ngModel]="item$.selected"/>
          <div class="text-truncate doc-permission-item-option"
               container='body' ngbTooltip="{{ 'ENUMS.' + $any(item).name | translate }}">
            {{ 'ENUMS.' + $any(item).name | translate }}
          </div>
        </div>
      </ng-template>

    </ng-select>
  </ng-template>

  <ng-template #deleteCol let-node>
    <pt-icon class='cursor-pointer opacity-25' *ngIf="isDisabled" [key]='IconRemove'></pt-icon>
    <pt-icon class='cursor-pointer' *ngIf="!isDisabled"
             [key]='IconRemove' (click)='removeGroupOrUser(node.row)'
    ></pt-icon>
  </ng-template>
</div>
